import { Command } from 'commands/Commands';

export class ChangeHasCustomPages extends Command {
  priority: number = 100;
  type: string = 'ChangeHasCustomPages';
}
